export const environment = {
  production: false,
  baseURL: 'https://prod-amgen-api.anuvabio.io/api/v3/',
  cronURL: 'https://prod-amgen-cron.anuvabio.io/api/v3/',
};
